/* eslint-disable no-console */
import { initializeApp } from 'firebase/app'
import {
  getMessaging as getFirebaseMessaging,
  getToken as getFirebaseToken,
  isSupported,
} from 'firebase/messaging'
import { openDB } from 'idb'
import { askNotificationPermission } from 'utils/notifications'

const messagingDB = 'firebase-messaging-database'
const messagingStore = 'firebase-messaging-store'
const installationsDB = 'firebase-installations-database'
const installationsStore = 'firebase-installations-store'

const firebaseConfig = {
  apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

export const getTokenFromDB = async (options = {}) => {
  const { clear = false } = options
  try {
    const db = await openDB(messagingDB)
    const store = db.transaction(messagingStore).objectStore(messagingStore)
    const values = await store.getAll()
    const token = values?.[0]?.token
    if (clear) {
      db.clear(messagingStore)
      const dbInstallations = await openDB(installationsDB)
      dbInstallations.clear(installationsStore)
    }
    return token
  } catch (e) {
    console.error("Couldn't open indexedDB", e)
    return null
  }
}

export const initFirebase = (onToken) => {
  if (!firebaseConfig.apiKey) {
    console.error('Firebase config is missing in .env file')
    return
  }
  const subscribe = () =>
    askNotificationPermission(() => {
      const firebaseApp = initializeApp(firebaseConfig)
      const messaging = getFirebaseMessaging(firebaseApp)
      getFirebaseToken(messaging, {
        vapidKey: import.meta.env.REACT_APP_FIREBASE_VAPID_KEY,
      })
        .then((currentToken) => {
          if (currentToken) onToken(currentToken)
        })
        .catch((e) => console.error(e))
    })
  const isAlreadyInitialized = () => getTokenFromDB().then((token) => !!token)
  isSupported().then((messagingIsSupported) => {
    if (!messagingIsSupported) return
    isAlreadyInitialized().then((isInit) => {
      if (isInit) return
      subscribe()
    })
  })
}

const createIDB = async (dbName, storeName) => {
  try {
    await openDB(dbName, 1, {
      upgrade(db, oldVersion, newVersion) {
        if (newVersion === 1) {
          const stores = db.objectStoreNames
          if (!stores.contains(storeName)) {
            db.createObjectStore(storeName)
          }
        }
      },
    })
  } catch (e) {
    console.error(`Error creating ${dbName}`, e)
  }
}

createIDB(messagingDB, messagingStore)
createIDB(installationsDB, installationsStore)
